import React from "react";
import "../styles/custom.css"
const Table = ({data}) => {
  return (
    <div className="contentBlock">
      <table className="table table-bordered">
        {data.map((item) => (
          <tbody key={item.title}>
            <tr>
              <td>{item.title}</td>
              <td>{item.value}</td>
            </tr>
          </tbody>
        ))}
      </table>
    </div>
  );
};

export default Table;
